import { render, staticRenderFns } from "./IntegrazioneBusinessView.vue?vue&type=template&id=3e35a58e"
import script from "./IntegrazioneBusinessView.vue?vue&type=script&lang=js"
export * from "./IntegrazioneBusinessView.vue?vue&type=script&lang=js"
import style0 from "./IntegrazioneBusinessView.vue?vue&type=style&index=0&id=3e35a58e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports